var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171.904,
    height: 152.859,
    viewBox: "0 0 171.904 152.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#e8d1b3;}.a,.b,.c,.d,.e,.f,.g,.h,.i,.j{fill-rule:evenodd;}.b{fill:#16232c;}.c{fill:#adadad;}.d{fill:#dedede;}.e{fill:#9a9a9a;}.f{fill:#d81212;}.g{fill:#ffd9c9;}.h{fill:#6f6571;}.i{fill:#d9d9d9;}.j{fill:#cbc7cb;}.k{fill:#a7160a;}.l{fill:#810c02;}.m{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-54 -89.91)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(54 89.91)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M382.021,228.265h41.122V242.55a6.43,6.43,0,0,1-6.412,6.417H401.94l-8.823,4.457-11.1-4.457v-20.7Z",
    transform: "translate(-261.158 -160.61)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M388.434,162.742h28.3a6.429,6.429,0,0,1,6.412,6.417v10.615H382.022V169.159A6.43,6.43,0,0,1,388.434,162.742Z",
    transform: "translate(-261.158 -115.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M382.022,206.463h41.122v10.088H382.022Z",
    transform: "translate(-261.158 -145.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M276.3,293.7h19.919v9.163a4.005,4.005,0,0,1-3.991,3.994H227.377c0-5.76,0-8.692,4.407-8.692l8.777-.009c5.525-.009,9.146-1.424,11.17-4.457H276.3Z",
    transform: "translate(-155.44 -205.343)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M177.26,335.289h57.032c3.344,5.825,6.033,12.825,3.714,26.213-3.88-13.2-43.293-7.933-47.34,7.3H147.178c-1.645-3.726-3.2-7.406-4.555-11.123h12.26c24.8-9.357,16.824-5.187,22.377-22.394Z",
    transform: "translate(-97.5 -233.774)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M237.8,149.163a93.091,93.091,0,0,0,3.3,12.64l12.536,4.912,13.979-4.912c-.49-26.454-10.375-39.139-18.783-43.245a20.409,20.409,0,0,0-6.135-3.176s-4.083,6.533-4.3,6.533c-1.571,3.735-2.162,8.608-2.06,13.869Z",
    transform: "translate(-161.558 -83.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M248.491,262.108H221.975c-6.107.666-13.618,5.317-13.618,19.722v15.1l6.018,3.584,7.822-3.584V285.261c0-5.76,0-8.692,4.407-8.692l8.777-.009c5.525-.009,9.146-1.424,11.17-4.457,1.562-2.339,2.162-5.64,1.941-10Z",
    transform: "translate(-142.438 -183.746)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M294.474,388.146a24.176,24.176,0,0,1,47.34-7.3,24.794,24.794,0,0,1,1.062,6.528c.028.888-.582.777-1.414.777q-23.49,0-46.989,0Z",
    transform: "translate(-201.309 -253.114)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M313.718,441.231h36.845a18.432,18.432,0,0,1-36.845,0Z",
    transform: "translate(-214.465 -306.198)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.085,428.81l31.7,7.3a16.264,16.264,0,1,1-31.7-7.3Z",
    transform: "translate(-11.395 -297.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.317,379.989a22.125,22.125,0,0,1,20.39-9.487c14.339,3.033,19,11.6,19.937,22.293a22.094,22.094,0,0,1-.49,4.374c-.092.407-.36.24-.8.139l-4.961-1.137-31.7-7.3-2.374-.545L0,387.562a21.948,21.948,0,0,1,3.317-7.573Z",
    transform: "translate(0 -257.772)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M74.845,269.308,87.65,225l5.765-2.58L99.864,225c-8.472,23.486-6.107,39.879-.388,55.524,1.367,3.717,2.92,7.4,4.555,11.123H94.82Z",
    transform: "translate(-51.166 -156.615)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M198.064,66.633l15.023-3.2c1.524.139,5.885,3.8,5.885,6.093l-3.2,16.255a14.672,14.672,0,0,1-4.2.619,14.526,14.526,0,0,1-13.507-19.769Z",
    transform: "translate(-134.731 -47.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M184.849,33.128a18.3,18.3,0,1,1,36.586,0c0,6.824-2.772,12.889-7.8,16.412a17.451,17.451,0,0,1-6.227,2.737V36.022c0-2.293-1.164-2.755-2.689-2.894H184.849Z",
    transform: "translate(-126.367 -14.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M189.866,372.171h13.84v8.719c0,1.868-1.016,2.006-2.513,2.006H181.329C180.932,374.15,186.226,372.171,189.866,372.171Z",
    transform: "translate(-123.946 -258.988)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M99.333,185.157l17.286,5.714c.85.758-.111,8.488-.684,8.238H95.841V186.387C95.841,183.881,97.144,184.436,99.333,185.157Z",
    transform: "translate(-65.52 -130.724)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M160.556,211.374h-8.74c-4.693,0-4.832-7.785.684-8.238l8.056-.647,2.162,4.577Z",
    transform: "translate(-101.399 -142.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M202.6,170.37l2.892-2.487c7.243-6.241,16.4,4.29,6.717,10.578l-8.149,5.289-4.1,2.663H186.981v-8.886l8.065-.656Z",
    transform: "translate(-127.824 -118.026)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M238.536,219.771Z",
    transform: "translate(-162.296 -154.048)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M21.4,0c11.82,0,21.4,9.145,21.4,20.425S33.222,40.85,21.4,40.85,0,31.705,0,20.425,9.582,0,21.4,0Z",
    transform: "translate(183.1 125.583)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M243.377,128.917a22.655,22.655,0,0,0-2.377.126c10.833,1.156,19.025,9.9,19.025,20.3s-8.192,19.143-19.025,20.3a22.646,22.646,0,0,0,2.377.126c11.82,0,21.4-9.145,21.4-20.425s-9.582-20.425-21.4-20.425Z",
    transform: "translate(-38.875 -3.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M16.268,14.314l5.957-5.944A1.391,1.391,0,1,0,20.258,6.4l-5.944,5.957L8.371,6.4A1.391,1.391,0,0,0,6.4,8.371l5.957,5.944L6.4,20.258a1.391,1.391,0,1,0,1.967,1.967l5.944-5.957,5.944,5.957a1.391,1.391,0,1,0,1.967-1.967Z",
    transform: "translate(189.366 132.604)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus6);
export default __webpack_public_path__ + "static/media/status-6.1f73e8afe52951fa50ef554fac6f456d.svg";
export { ForwardRef as ReactComponent };